// Staff review queue: submitted plans waiting for a decision
export const FETCH_PENDING_REVIEWS = 'DP_FETCH_PENDING_REVIEWS';
export const FETCH_PENDING_REVIEWS_SUCCESS = 'DP_FETCH_PENDING_REVIEWS_SUCCESS';
export const FETCH_PENDING_REVIEWS_ERROR = 'DP_FETCH_PENDING_REVIEWS_ERROR';
